import { AccUpgradeState } from './index';
import { Accommodation, AvailableAccommodationUpgrades } from '../interfaces/availableAccommodationUpgrade';
import { ActionTree } from 'vuex';
import { IStore } from "@store/index";
import { AxiosError, AxiosResponse } from "axios";
import CheckoutItem from "../interfaces/checkoutItem";
import { postResponse } from "@store/services/fetchCheckoutData";

export default {
    async getAvailableAccUpgrades({ commit, dispatch, rootState }) {
        if (rootState.checkout.checkoutSummary.rooms.length === 0) {
            return;
        }

        await postResponse(
            rootState.checkout.apiEndpoint,
            'GetAccUpgrades',
            rootState.checkout.apiToken,
            {
                'tripUid': rootState.checkout.checkoutSummary.tripId,
                'appointmentId': rootState.checkout.checkoutSummary.appointmentId,
                'chosenRooms': rootState.checkout.checkoutSummary.rooms,
                'fare': rootState.checkout.checkoutSummary.fare,
                'sessionId': rootState.checkout.checkoutSettings.sessionId
            },
            rootState.checkout.checkoutSettings.locale
        )
            .then((response: AxiosResponse) => {
                commit('setAvailableUpgrades', response.data);
                dispatch('setInitialAccommodationUpgrades');
            })
            .catch((e: AxiosError) => {
                const responseStatus = e.response ? e.response.status : 'none';
                const message = `Error in getAvailableAccUpgrades | Error code: 1642576679331 | HTTP status: ${responseStatus} | ${e.message}`;

                dispatch('openErrorOverlay');

                throw Error(message);
            });
    },

    updateAccommodationUpgrades({ commit, dispatch, getters }, [upgradeId, currentDay]) {
        const dayKey: string = currentDay.replace(/\s/g, '');
        const availableUpgrades: AvailableAccommodationUpgrades[] = getters.getAvailableAccUpgrades;
        const upgrades: AvailableAccommodationUpgrades = availableUpgrades.filter(day => day.day === currentDay)[0];
        const filteredUpgrade: Accommodation[] = upgrades.accommodations.filter(accommodation => accommodation.id === upgradeId);
        const chosenUpgrade: Accommodation = { ...filteredUpgrade[0], day: currentDay };
        const accommodationUpgrades: CheckoutItem[] = [];
        const currentAcc = getters.getAccUpgrades;

        commit('setAccommodationUpgrades', [dayKey, chosenUpgrade]);

        // @ts-ignore
        Object.values(currentAcc).forEach((item: Accommodation) => {
            if (item.calculationStatus !== 'STANDARD') {
                const checkoutSummaryHotelUpgradeItem: CheckoutItem = {
                    id: item.id,
                    amount: 1
                }
                accommodationUpgrades.push(checkoutSummaryHotelUpgradeItem);
            }
        })

        commit('checkout/mapAccommodationUpgradesToCheckoutSummary', accommodationUpgrades, { root: true });
        dispatch('updatePriceSummary');
    },

    setInitialAccommodationUpgrades({ commit, getters, rootGetters, dispatch }) {
        const availableAccUpgrades: AvailableAccommodationUpgrades[] = getters.getAvailableAccUpgrades;
        const currentUpgrades: CheckoutItem[] = rootGetters['checkout/getAccommodationUpgrades'];
        const days: any = {};

        availableAccUpgrades.forEach((day: AvailableAccommodationUpgrades) => {
            const dayKey: string = day.day.replace(/\s/g, '');
            let chosenAccommodationUpgrade: Accommodation | undefined;

            day.accommodations.forEach((accommodation) => {
                if(currentUpgrades.find(acc => acc.id === accommodation.id)) {
                    chosenAccommodationUpgrade = accommodation;
                }
            })

            if (!chosenAccommodationUpgrade) {
                chosenAccommodationUpgrade = day.accommodations.find(accommodation => accommodation.calculationStatus === 'STANDARD');
            }

            days[dayKey] = { ...chosenAccommodationUpgrade, day: day.day };
        })

        commit('initAccommodationUpgrades', days);
        dispatch('funnel/addSelectedToCheckoutFunnel', { type: 'hotelUpgrades', picked: days }, { root: true });
    }

} as ActionTree<AccUpgradeState, IStore>
